// extracted by mini-css-extract-plugin
module.exports = {"editButton":"style_editButton__oQIBA"};